import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Card } from './../../../../models/card.model';

@Component({
  selector: 'lns-credit-card',
  templateUrl: './credit-card.component.html',
  styleUrls: ['./credit-card.component.scss']
})
export class CreditCardComponent {
  @Input() bankCardData: Card | undefined;
  environment = environment;
}
